export interface PaidTiers {
  name: 'Starter' | 'Pro';
  description: string;
  features: string[];
  priceId: { month: string; year: string };
}

function envString(value: string | undefined): string {
  return typeof value === 'string' ? value.trim() : '';
}

export function proPriceIds(): { month: string; year: string } {
  return {
    month: envString(import.meta.env.VITE_PADDLE_PRO_PRICE_ID_MONTH),
    year: envString(import.meta.env.VITE_PADDLE_PRO_PRICE_ID_YEAR),
  };
}

export function starterPriceIds(): { month: string; year: string } {
  return {
    month: envString(import.meta.env.VITE_PADDLE_STARTER_PRICE_ID_MONTH),
    year: envString(import.meta.env.VITE_PADDLE_STARTER_PRICE_ID_YEAR),
  };
}

export const paidStarter: PaidTiers = {
  name: 'Starter',
  description:
    'The spreadsheet and Proposals for your own AI, connected over MCP.',
  features: [
    '5,000 cell edits a month',
    'Proposals, review, and merge from any MCP client',
    'History, restore, export, and sharing',
  ],
  get priceId() {
    return starterPriceIds();
  },
};

export const paidPro: PaidTiers = {
  name: 'Pro',
  description:
    'Every agent in Exis, and Autocomplete and Repairer in Google Sheets.',
  features: [
    '10,000 cell edits a month',
    'Oracle, Autocomplete, Repairer, Formatter, and Routines in the Exis editor',
    'One allowance across the Exis editor and Google Sheets',
  ],
  get priceId() {
    return proPriceIds();
  },
};
